<template lang="pug">
div
    div(
        v-if="sectionTitle && tip"
    )
        tl-position
            tl-tooltip-container(
                :tip="tip"
            )
                h2(class="title-3 weight-regular text-opaq")
                    slot
        tl-space(
            small
        )
    div(
        v-else-if="sectionTitle"
    )
        h2(class="title-3 weight-regular text-opaq")
            slot
        tl-space(
            xsmall
        )

    div(
        v-else-if="cardTitle"
    )
        h2(class="title-3")
            slot
        tl-space(
            xsmall
        )

    div(
        v-else-if="cardDescription"
    )
        p(class="text-4 text-color-navy-light")
            slot
        tl-space(
            xsmall
        )

    div(
        v-else-if="dialogTitle"
    )
        .dialog-title-wrapper
            h2(class="title-2")
                slot
            .close-icon(
                v-if="closeIcon"
                @click="emit('close-click')"
            )
                i.mi-close

        div(
            v-if="description"
        )
            p(
class="text-4 text-color-navy-light"
style="margin-top: 3px") {{ description }}

        tl-space(
            xsmall
        )

    div(
        v-else-if="listTitle"
    )
        h3(class="caption-5 text-color-navy-light uppercase")
            slot
        tl-space(
            xsmall
        )

    div(
        v-else
    )
        slot
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    sectionTitle: Boolean,
    dialogTitle: Boolean,
    listTitle: Boolean,
    cardTitle: Boolean,
    cardDescription: Boolean,
    description: String,
    tip: String,
    closeIcon: Boolean,
})

const sectionTitle = computed(() => !!props.sectionTitle)
const dialogTitle = computed(() => !!props.dialogTitle)
const listTitle = computed(() => !!props.listTitle)
const cardTitle = computed(() => !!props.cardTitle)
const cardDescription = computed(() => !!props.cardDescription)

const emit = defineEmits(['close-click'])
</script>

<style lang="sass" scoped>
.dialog-title-wrapper
    position: relative
    .title-2
        line-height: 1.6em
        padding-right: 30px

.close-icon
    position: absolute
    right: 0
    top: 50%
    transform: translateY(-50%)
    font-size: 24px
    cursor: pointer
</style>
